import BaseModel from './BaseModel'
import { VenueLocationProduct } from './VenueLocationProduct'

export default class Venue extends BaseModel {

  static entity = 'venues'
  static primaryKey = 'ID'

  declare ID: number
  declare name: string
  declare formattedAddress: string
  declare channels: string[]
  declare venueLocationProducts: VenueLocationProduct[]

  static fields() {

    return {

      // fields
      ID: this.number(null),
      name: this.string(null),
      formattedAddress: this.string(null),
      channels: this.attr([]), // array of strings - virtual column

      // relationships
      venueLocationProducts: this.hasMany(VenueLocationProduct, 'venueID'),

    }

  }

  /**
   * API methods
   */

  static fetchLocationVenues(locationID: number) {

    return this.api().get(`/venues/location/${locationID}/venue`, {
      dataKey: 'venues',
    })

  }

}
